// Environment-aware API base URLs.
//   `npm run dev`   → import.meta.env.DEV = true  → talk to the LOCAL backend
//   `npm run build` → talk to whatever VITE_API_BASE says, defaulting to production
//
// The default matters more than it looks. A build with no VITE_API_BASE targets
// https://aonelao.com — so a bundle built for a test environment and deployed there would
// still send every write to the PRODUCTION database, from a UI nobody thinks is live. The
// UAT build must therefore set VITE_API_BASE explicitly:
//
//   VITE_API_BASE=https://aonelao.com:5555 VITE_WA_BASE= npm run build
//
// An empty VITE_WA_BASE disables the WhatsApp service calls, which is what a test
// environment wants: the production service on :8443 sends real messages to real customers.
const isDev = import.meta.env.DEV;

const PROD_API = 'https://aonelao.com';
const PROD_WA = 'https://aonelao.com:8443';

// const ApiLink = 'https://172.21.4.70:5003';
// const ApiLink = 'https://application.besttelecom.la:5003';
// Production: served behind Nginx (443 -> backend :5003), same origin as the SPA.
const ApiLink = isDev
    ? 'http://localhost:5003'
    : (import.meta.env.VITE_API_BASE || PROD_API);
export default ApiLink;

// Standalone whatsappapi service (per-branch WhatsApp Web). Shares the ERP
// session token. Production: exposed via Nginx on a dedicated HTTPS port (8443 -> :5001).
// Set VITE_WA_BASE='' on a test build to leave it unset rather than pointed at production.
export const WhatsAppApiLink = isDev
    ? 'http://localhost:5001'
    : (import.meta.env.VITE_WA_BASE !== undefined ? import.meta.env.VITE_WA_BASE : PROD_WA);

// True when this bundle was built for somewhere other than production. Screens can use it to
// say so on the page — an environment that looks identical to production is one where
// somebody eventually does real work in it by mistake.
export const IS_UAT = !isDev && !!import.meta.env.VITE_API_BASE
    && import.meta.env.VITE_API_BASE !== PROD_API;
